import React, { FC, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import { useFormState } from 'react-final-form';
import { PAYMENT_OPTION } from 'models/Listing';
import { CollapsibleSection } from 'components/CollapsibleSection';
import classNames from 'classnames';
import { transformPriceNumberToCurrencyString } from 'utils';
import ListingContext from 'router/subrouters/ListingCreationWizard/providers/Listing/Listing.context';

import './TermsOfPayment.styles.scss';

const daysOverdue = [
  'lessThat8Warning',
  'after8Days10percent',
  '28DayIncrement',
  '75DayIncrement',
];

type TermsOfPaymentProps = { className?: string; amount: number };

const TermsOfPayment: FC<TermsOfPaymentProps> = ({ className, amount }) => {
  const { t } = useTranslation();

  const {
    values: { paymentOption },
    submitting,
    invalid,
  } = useFormState();

  const {
    listing: { listingTitle },
  } = useContext(ListingContext);

  const isPaymentInvoice = useMemo(
    () => paymentOption === PAYMENT_OPTION.INVOICE,
    [paymentOption],
  );

  return (
    <>
      <CollapsibleSection
        className={classNames('terms-of-payment', className)}
        trigger={
          <div className="terms-of-payment__trigger">
            {t('termsOfPayment')} <p>{t('byClickingProceedAgree')}</p>
          </div>
        }
      >
        <div className="terms-of-payment__content">
          <p>
            {t('youAgreeToPayFullAmount', {
              amount: transformPriceNumberToCurrencyString(amount),
              listing: listingTitle,
            })}
          </p>
          <p>{t('underAustraliaTradePracticesAct')}</p>
          <p>
            <b>{t('daysOverdue')}</b>
          </p>

          <ul>
            {daysOverdue.map((el) => (
              <li key={el}>{t(el)}</li>
            ))}
          </ul>
        </div>
      </CollapsibleSection>

      {isPaymentInvoice && (
        <Button type="submit" disabled={submitting || invalid}>
          {t('proceed')}
        </Button>
      )}
    </>
  );
};

export default TermsOfPayment;
